var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "handle-box" },
        [
          _c(
            "el-form",
            {
              ref: "queryCondition",
              staticClass: "searchForm",
              attrs: { model: _vm.queryCondition, "label-width": "140px" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      `${_vm.type}Manage.${_vm.type}No`
                                    ),
                                    prop: "serialNo",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryCondition.serialNo,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "serialNo",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "queryCondition.serialNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      `${_vm.type}Manage.${_vm.type}Name`
                                    ),
                                    prop: "name",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryCondition.name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "name",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "queryCondition.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Initiator",
                                    prop: "creator",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryCondition.creator,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "creator",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "queryCondition.creator",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "Status", prop: "status" } },
                                [
                                  _c("ic-select", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      table: "TT_SSR",
                                      field: "STATUS_VIEW",
                                      placeholder: _vm.$t("BC.sel"),
                                    },
                                    model: {
                                      value: _vm.queryCondition.status,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "status",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.status",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-collapse-transition",
                    [
                      _vm.isShow
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "ssrManage.category1"
                                            ),
                                            prop: "category1Id",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                clearable: "",
                                                placeholder: _vm.$t("BC.sel"),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.changeCategory1()
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .category1Id,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "category1Id",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.category1Id",
                                              },
                                            },
                                            _vm._l(
                                              _vm.categoryList1,
                                              function (item, index) {
                                                return _c("el-option", {
                                                  key: index,
                                                  attrs: {
                                                    label: item.name,
                                                    value: item.tmCategoryId,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "ssrManage.category2"
                                            ),
                                            prop: "category2Id",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                clearable: "",
                                                placeholder: _vm.$t("BC.sel"),
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .category2Id,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "category2Id",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.category2Id",
                                              },
                                            },
                                            _vm._l(
                                              _vm.categoryList2,
                                              function (item, index) {
                                                return _c("el-option", {
                                                  key: index,
                                                  attrs: {
                                                    label: item.name,
                                                    value: item.tmCategoryId,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "Release Date(From)",
                                            prop: "issueDateFrom",
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              "value-format": "yyyy-MM-dd",
                                              type: "date",
                                              placeholder: "Select Date",
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition
                                                  .issueDateFrom,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "issueDateFrom",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.issueDateFrom",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "Release Date(To)",
                                            prop: "issueDateTo",
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              "value-format": "yyyy-MM-dd",
                                              type: "date",
                                              placeholder: "Select Date",
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition.issueDateTo,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "issueDateTo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.issueDateTo",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center", align: "middle" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          ;(_vm.queryCondition.pageNum = 1), _vm.queryData()
                        },
                      },
                    },
                    [_vm._v("Search")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.restQueryForm },
                    },
                    [_vm._v("Reset")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "arrowDown",
                      on: {
                        click: function ($event) {
                          _vm.isShow = !_vm.isShow
                        },
                      },
                    },
                    [
                      _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                      _c("i", {
                        class: _vm.isShow
                          ? "el-icon-arrow-up iconBtn"
                          : "el-icon-arrow-down iconBtn",
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "action-btn-row" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "acl",
                  rawName: "v-acl",
                  value: _vm.Create_SSR,
                  expression: "Create_SSR",
                },
              ],
              staticClass: "btn",
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.newBuilt },
            },
            [_vm._v("New")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "tableList",
          attrs: {
            data: _vm.tableList,
            "row-key": "ttSsrId",
            border: "",
            "highlight-current-row": "",
            "max-height": "420",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              sortable: "",
              type: "selection",
              width: "55",
              align: "center",
              "reserve-selection": true,
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "no",
              label: _vm.$t(`${_vm.type}Manage.${_vm.type}No`),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "a-link",
                        on: {
                          click: function ($event) {
                            return _vm.toDetail(scope.row.ttSsrId)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.serialNo) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "name",
              label: _vm.$t(`${_vm.type}Manage.${_vm.type}Name`),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "creator",
              label: "Initiator",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "status",
              label: "Status",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(_vm.status(scope.row)))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "isSpecUpload",
              label: _vm.$t("ssrManage.specUpload"),
            },
          }),
          _c(
            "el-table-column",
            {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "status",
                label: _vm.$t(`${_vm.type}Manage.${_vm.type}Initiate`),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("ic")(
                              scope.row.issueDate == null ? 0 : 1,
                              "COMMON",
                              "YES_NO_NUMBER"
                            )
                          ) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            },
            [_vm._v("fpaPdfDownload ")]
          ),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "proposal",
              label: _vm.$t("ssrManage.proposal"),
              width: "80",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("romanNum")(scope.row.currentRound)) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "recommendation",
              label: _vm.$t("ssrManage.recommendation"),
              width: "130",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("ic")(
                            ["RECOMMENDATION", "BC_CREATED"].includes(
                              scope.row.status
                            )
                              ? 1
                              : 0,
                            "COMMON",
                            "YES_NO_NUMBER"
                          )
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "bc",
              label: _vm.$t("ssrManage.bc"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("ic")(
                            scope.row.ttBcId != null ? 1 : 0,
                            "COMMON",
                            "YES_NO_NUMBER"
                          )
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.queryCondition.pageNum,
              "page-sizes": _vm.pageSizeList,
              "page-size": _vm.queryCondition.pageSize,
              layout: _vm.pageLayout,
              total: _vm.totalCount,
            },
            on: {
              "size-change": _vm.pageSizeChange,
              "current-change": _vm.pageNumberChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }